import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductFavoriteIconMHComponent } from './product-favorite-icon.component';


@NgModule({
  declarations: [
    ProductFavoriteIconMHComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ProductFavoriteIconMHComponent,
  ]
})
export class ProductFavoriteIconModule { }
